let isRequested = false
let isMounted = false

const listeners = new Set<() => void>()
const mountListeners = new Set<() => void>()

export const requestToaster = () => {
    if (isRequested) {
        return
    }

    isRequested = true
    listeners.forEach(listener => listener())
}

export const subscribeToaster = (listener: () => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}

export const getIsToasterRequested = () => isRequested

export const markToasterMounted = () => {
    isMounted = true
    mountListeners.forEach(listener => listener())
    mountListeners.clear()
}

/**
 * sonner hands a toast to its current subscribers only, so one published between `requestToaster` and
 * the lazy toaster's mount is lost with no trace. Resolves early on timeout: a caller must still get
 * its toast attempt through even on a page that never mounts a toaster.
 */
export const waitForToasterMount = (timeoutMs: number) => {
    // No subscriber means no `Toaster` in the tree at all, so nothing is ever going to mount.
    if (isMounted || listeners.size === 0) {
        return Promise.resolve()
    }

    return new Promise<void>(resolve => {
        let timer: ReturnType<typeof setTimeout>

        const settle = () => {
            clearTimeout(timer)
            mountListeners.delete(settle)
            resolve()
        }

        timer = setTimeout(settle, timeoutMs)
        mountListeners.add(settle)
    })
}
